import React from 'react';
import { Link } from 'react-router-dom';

export function ProssimiShowBanner({ shows }) {
  function formatShowDate(date) {
    return date.toLocaleDateString('it-IT', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    });
  }

  if (shows.length === 0) return null;

  return (
    <div
      className="card shadow-sm mt-4 mb-4"
      style={{ backgroundColor: 'var(--brand-bg-dark)' }}
    >
      {/* Header */}
      <div className="card-header border-0 position-relative px-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="bi bi-calendar-event text-brand-secondary me-2"></i>
            <h6 className="mb-0 brand-title">Prossimi Show</h6>
          </div>
          <Link
            to="/next-shows"
            className="btn btn-sm"
            style={{ whiteSpace: 'nowrap' }}
          >
            <span className="show-link brand-link cursor-pointer fs-small">

              Vedi tutti
              <i className="bi bi-chevron-right ms-1"></i>
            </span>
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="card-body p-0">
        <div className="list-group list-group-flush">
          {shows.slice(0, 3).map((show) => (
            <Link
              key={show.id}
              to={`/shows/${show.id}`}
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 border-0"
              style={{
                backgroundColor: 'transparent',
                backgroundImage: show.sfondo
                  ? `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${show.sfondo})`
                  : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.2s ease-in-out',
              }}
              onMouseEnter={(e) => {
                if (show.sfondo) {
                  e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${show.sfondo})`;
                }
              }}
              onMouseLeave={(e) => {
                if (show.sfondo) {
                  e.currentTarget.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${show.sfondo})`;
                }
              }}
            >
              <div className="d-flex align-items-center w-100">
                {show.logo && (
                  <img
                    src={show.logo}
                    alt={show.nome}
                    className="img-fluid me-3"
                    style={{ maxHeight: '30px' }}
                  />
                )}
                <div>
                  <h6 className="mb-0 fw-semibold text-white">
                    {show.nome}
                  </h6>
                  <small className="text-white-50">
                    {formatShowDate(show.date || show.data)}
                  </small>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}


